var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},[_c('p',{staticClass:"navbar-content"},[_vm._v(" Central de atendimento: "),_c('a',{staticClass:"navbar-content__link",attrs:{"href":'tel:+55 11' + _vm.tel}},[_vm._v(_vm._s(_vm.tel))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }